'use client';

import { useEffect, useState } from 'react';
import { marketplaceNav } from '@/config/marketplaceNav';
import { useAuth } from '@/platform/auth/useAuth';
import { getSellerState, type SellerCapabilities } from '@/platform/vendor/api';

/** True when the user has started or completed any seller path (haul, vendor, or in-progress setup). */
export function hasSellerAccount(state: SellerCapabilities): boolean {
  return (
    state.canListFinds ||
    state.canManageCatalog ||
    state.marketplaceTermsAccepted ||
    state.connectOnboardingComplete ||
    state.vendorEnabled ||
    state.vendorVerificationStatus !== 'none'
  );
}

export function resolveMarketplaceSellLabel(
  state: SellerCapabilities | null,
  isAuthenticated: boolean,
): string {
  if (!isAuthenticated || !state || !hasSellerAccount(state)) {
    return marketplaceNav.becomeSellerLabel;
  }
  return marketplaceNav.sell.label;
}

/** Dynamic label for the marketplace sell / seller-dashboard nav entry. */
export function useMarketplaceSellLabel(): string {
  const { user, isAuthenticated } = useAuth();
  const [label, setLabel] = useState<string>(marketplaceNav.becomeSellerLabel);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setLabel(marketplaceNav.becomeSellerLabel);
      return;
    }
    getSellerState()
      .then((state) => setLabel(resolveMarketplaceSellLabel(state, true)))
      .catch(() => setLabel(marketplaceNav.becomeSellerLabel));
  }, [isAuthenticated, user]);

  return label;
}
